import { render, staticRenderFns } from "./vehicleTeamAdd.vue?vue&type=template&id=f87344dc&scoped=true"
import script from "./vehicleTeamAdd.vue?vue&type=script&lang=js"
export * from "./vehicleTeamAdd.vue?vue&type=script&lang=js"
import style0 from "./vehicleTeamAdd.vue?vue&type=style&index=0&id=f87344dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87344dc",
  null
  
)

export default component.exports